import React from 'react';

function PlayerStatsRow({ statRow }) {
  return (
    <div className="stats-table__row" style={{ minWidth: '775px' }}>
      <div className="stats-table__generic">{statRow.year}</div>
      <div className="stats-table__generic stats-table__generic--team-name flex-lg-grow-1 d-flex">
        <div className="name-with-team-logo">
          <span className="text-color-primary-yellow">{statRow.teamName}</span>
        </div>
      </div>
      <div className="stats-table__generic text-start">
        {statRow.leagueName}
      </div>
      <div className="stats-table__generic text-end">
        {statRow.matchesPlayed}
      </div>
      <div className="stats-table__generic text-end">
        {statRow.matchesStarted}
      </div>
      <div className="stats-table__generic text-end">{statRow.goals}</div>
      <div className="stats-table__generic text-end">{statRow.assists}</div>
      <div className="stats-table__generic text-end">{statRow.yellowCards}</div>
      <div className="stats-table__generic text-end">{statRow.redCards}</div>
    </div>
  );
}

export default PlayerStatsRow;
